(function() {
  $.widget('custom.message_writer', {
    options: {
      infoClass: 'alert alert-info',
      warnClass: 'alert alert-warn',
      errorClass: 'alert alert-error',
      successClass: 'alert alert-success',
      generalClass: 'alert',
      fadeInTime: 400,
      fadeOutTime: 400,
      hideTime: 3500,
      autoHide: true
    },
    _create: function() {
      this.element.hide();
      return this.setInitialClass();
    },
    _setOption: function(key, value) {
      return void 0;
    },
    destroy: function() {
      return void 0;
    },
    setInitialClass: function() {
      return this.initialClass = this.element.attr('class');
    },
    write: function(json, do_hide, callback) {
      var msg, type;
      if (callback == null) {
        callback = null;
      }
      type = json.status.type;
      msg = json.status.msg;
      if (do_hide == null) {
        return this[type](msg, false, callback);
      } else {
        return this[type](msg, do_hide, callback);
      }
    },
    info: function(msg, do_hide, callback) {
      if (do_hide == null) {
        do_hide = false;
      }
      if (callback == null) {
        callback = null;
      }
      this._setMsg('info', msg, callback);
      if (do_hide) {
        return this.hide();
      }
    },
    warn: function(msg, do_hide, callback) {
      if (do_hide == null) {
        do_hide = false;
      }
      if (callback == null) {
        callback = null;
      }
      this._setMsg('warn', msg, callback);
      if (do_hide) {
        return this.hide();
      }
    },
    success: function(msg, do_hide, callback) {
      if (do_hide == null) {
        do_hide = false;
      }
      if (callback == null) {
        callback = null;
      }
      this._setMsg('success', msg, callback);
      if (do_hide) {
        return this.hide();
      }
    },
    error: function(msg, do_hide, callback) {
      if (do_hide == null) {
        do_hide = false;
      }
      if (callback == null) {
        callback = null;
      }
      this._setMsg('error', msg, callback);
      if (do_hide) {
        return this.hide();
      }
    },
    general: function(msg, do_hide, callback) {
      if (do_hide == null) {
        do_hide = false;
      }
      if (callback == null) {
        callback = null;
      }
      this._setMsg('general', msg, callback);
      if (do_hide) {
        return this.hide();
      }
    },
    _setMsg: function(type, msg, cb) {
      var css;
      this.element.html(msg);
      css = this.options[type + "Class"];
      this.element.attr('class', this.initialClass + " " + css);
      return this.show(cb);
    },
    hide: function(timeout) {
      if (timeout == null) {
        timeout = this.options.hideTime;
      }
      return setTimeout((function(_this) {
        return function() {
          if (!_this.element.is(':visible')) {
            return;
          }
          return _this.element.fadeOut(_this.options.fadeOutTime);
        };
      })(this), timeout);
    },
    show: function(cb) {
      return this.element.fadeIn(this.options.fadeInTime, cb);
    },
    clear: function() {
      this.element.stop(true);
      return this.element.fadeOut(this.options.fadeOutTime);
    }
  });

}).call(this);
